// extracted by mini-css-extract-plugin
export default {"container":"styles_container__plG1H","description":"styles_description__ZIH6V","engineer_gr":"styles_engineer_gr__SMIQ7","blockchain_gr":"styles_blockchain_gr__Rq5Tn"};